module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div id="uploader_overlay"></div>\n<div id="uploader_frame" class="' +
((__t = ( addClassIfTrue(albumType === 'story', 'story') )) == null ? '' : __t) +
'" role="dialog" aria-modal="true" aria-label="' +
((__t = ( I18n.t('widget.upload_now') )) == null ? '' : __t) +
'" aria-describedby=\'modalDescription\'>\n	<h1 class="screen_reader_only">' +
((__t = ( I18n.t('widget.screen_reader_only.uploader.title') )) == null ? '' : __t) +
'</h1>\n	<p class=\'screen_reader_only\' id=\'modalDescription\'>' +
((__t = ( I18n.t('widget.screen_reader_only.uploader.description') )) == null ? '' : __t) +
'</p>\n	<div id="top_bar">\n		<button id="close" aria-label="' +
((__t = ( I18n.t('common.controls.close') )) == null ? '' : __t) +
'"></button>\n		<div id="breadcrumbs_container" class="one">\n			<div role="button" id="pick_source" class="breadcrumb one">\n				<span class="number">1</span>\n				<span class="text">' +
((__t = ( I18n.t('uploader.breadcrumbs.step_one') )) == null ? '' : __t) +
'</span>\n			</div>\n			<div class="bar two"></div>\n			<div role="button" id="select_content" class="breadcrumb two">\n				<span class="number">2</span>\n				<span class="text">' +
((__t = ( I18n.t('uploader.breadcrumbs.step_two') )) == null ? '' : __t) +
'</span>\n			</div>\n			<div class="bar three"></div>\n			<div role="button" id="review_submission" class="breadcrumb three">\n				<span class="number">3</span>\n				<span class="text">' +
((__t = ( I18n.t('uploader.breadcrumbs.step_three') )) == null ? '' : __t) +
'</span>\n			</div>\n			<div class="bar four"></div>\n			<div role="button" id="submit_content" class="breadcrumb four">\n				<span class="number">4</span>\n				<span class="text">' +
((__t = ( I18n.t('uploader.breadcrumbs.step_four') )) == null ? '' : __t) +
'</span>\n			</div>\n		</div>\n	</div>\n	<h2 id="breadcrumbs_hidden_title" class="screen_reader_only">' +
((__t = ( I18n.t('uploader.breadcrumbs.step_one') )) == null ? '' : __t) +
'</h2>\n	<div id="upload_holder"></div>\n	<div id="content_holder"></div>\n	<div id="info_holder"></div>\n	<div id="uploader_loader"></div>\n	<div id="uploader_error" class="alert" role="dialog" aria-modal="true">\n		<h1 id="uploader_error_title">' +
((__t = ( I18n.t('uploader.alerts.alert_title') )) == null ? '' : __t) +
'</h1>\n		<span id="uploader_error_description">' +
((__t = ( I18n.t('uploader.alerts.failed.alert_desc') )) == null ? '' : __t) +
'</span>\n		<button id="uploader_error_button" aria-label="' +
((__t = ( I18n.t('uploader.alerts.close_alert') )) == null ? '' : __t) +
'">' +
((__t = ( I18n.t('uploader.alerts.close_alert') )) == null ? '' : __t) +
'</button>\n	</div>\n	<div id="uploader_alert" class="alert" role="dialog" aria-modal="true">\n		<h1 id="alert_title">' +
((__t = ( I18n.t('uploader.alerts.close.alert_title') )) == null ? '' : __t) +
'</h1>\n		<div id="alert_desc_top">' +
((__t = ( I18n.t('uploader.alerts.close.alert_desc') )) == null ? '' : __t) +
'</div>\n		<div id="alert_desc_bottom">' +
((__t = ( I18n.t('uploader.alerts.close.alert_confirm') )) == null ? '' : __t) +
'</div>\n		<div id="alert_option">\n			<button id="no">' +
((__t = ( I18n.t('uploader.alerts.no') )) == null ? '' : __t) +
'</button>\n			<button id="yes">' +
((__t = ( I18n.t('uploader.alerts.yes') )) == null ? '' : __t) +
'</button>\n		</div>\n	</div>\n	<div id="uploader_back_alert" class="alert" role="dialog" aria-modal="true">\n		<h1 id="alert_back_title">' +
((__t = ( I18n.t('uploader.alerts.back.alert_title') )) == null ? '' : __t) +
'</h1>\n		<div id="alert_back_desc_top">' +
((__t = ( I18n.t('uploader.alerts.back.alert_desc') )) == null ? '' : __t) +
'</div>\n		<div id="alert_back_desc_bottom">' +
((__t = ( I18n.t('uploader.alerts.back.alert_confirm') )) == null ? '' : __t) +
'</div>\n		<div id="alert_back_option">\n			<button id="alert_back_no">' +
((__t = ( I18n.t('uploader.alerts.back.no') )) == null ? '' : __t) +
'</button>\n			<button id="alert_back_yes" data="">' +
((__t = ( I18n.t('uploader.alerts.back.yes') )) == null ? '' : __t) +
'</button>\n		</div>\n	</div>\n	<div id="file_alert" class="alert" role="dialog" aria-modal="true">\n		<h1 class="alert_title">' +
((__t = ( I18n.t('uploader.alerts.alert_title') )) == null ? '' : __t) +
'</h1>\n		<div id="file_type" class="file_alert_message">\n			<div class="alert_header">' +
((__t = ( I18n.t('uploader.alerts.file.format_error') )) == null ? '' : __t) +
'</div>\n			<div class="alert_desc">' +
((__t = ( I18n.t('uploader.alerts.file.format_details') )) == null ? '' : __t) +
'</div>\n			<div id="alert_format"></div>\n		</div>\n		<div id="file_size" class="file_alert_message">\n			<div class="alert_header">' +
((__t = ( I18n.t('uploader.alerts.file.size_error') )) == null ? '' : __t) +
'</div>\n			<div class="alert_desc">' +
((__t = ( I18n.t('uploader.alerts.file.size_details') )) == null ? '' : __t) +
'</div>\n		</div>\n		<div id="file_amount" class="file_alert_message">\n			<div class="alert_header">' +
((__t = ( I18n.t('uploader.alerts.file.amount_error') )) == null ? '' : __t) +
'</div>\n			<div class="alert_desc">' +
((__t = ( I18n.t('uploader.alerts.file.amount_details') )) == null ? '' : __t) +
'</div>\n		</div>\n		<div id="alert_option">\n			<button id="yes_file">' +
((__t = ( I18n.t('uploader.alerts.ok') )) == null ? '' : __t) +
'</button>\n		</div>\n	</div>\n</div>\n';

}
return __p
}